import { Fragment, useEffect, useState } from "react";
import { AdditionalProducts } from "../addtionalProducts";
import { FamilyProductContainer, ProductViewToggle, useIsDesktopView } from "../productListing";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
import { isValidArray } from "../../../Layout/Common/common";

export const HybridProductContainer = ({ familyDetails, ishybrid }) => {
  const { getSubFamilyDetails, getFamilyProducts } = useGlobalFunction();
  const [subfamily, setSubfamily] = useState(null);
  const [productList, setProductList] = useState(null);
  const [view, setView] = useState("table");
  const isDesktop = useIsDesktopView();
  const activeView = isDesktop ? view : "grid";
  useEffect(() => {
    if (familyDetails && familyDetails.familyId) {
      loadsubfamily(familyDetails.familyId);
    }
    fetchFamilyProduct(familyDetails.familyId);
  }, [familyDetails]);

  const loadsubfamily = async (familyId) => {
    let results = await getSubFamilyDetails(familyId);
    if (results && isValidArray(results)) {
      const seenFamilyIds = new Set();
      const uniqueFamilies = results.filter((item) => {
        if (seenFamilyIds.has(item.familyId)) return false;
        seenFamilyIds.add(item.familyId);
        return true;
      });
      setSubfamily(uniqueFamilies);
    } else setSubfamily(null);
  };

  const fetchFamilyProduct = async (fid) => {
    let response = await getFamilyProducts(fid);
    if (isValidArray(response)) {
      setProductList(response);
    } else {
      setProductList([]);
    }
  };

  return (
    <Fragment>
      {((familyDetails.isFamily == true && ishybrid == false) || subfamily) && (
        <section className="section-padding secton-aboutProduct" id="section-ProductsList">
          <div className="container-fluid container-lg">
            <div className="row">
              <div className="col-lg-12">
                {(isValidArray(productList) || subfamily) && (
                  <div className="proSection-title subcategory-title">
                    <h4>Products</h4>
                    {isDesktop && <ProductViewToggle view={view} onChange={setView} />}
                  </div>
                )}
                {familyDetails.isFamily == true && ishybrid == false && (
                  <FamilyProductContainer params={familyDetails} view={activeView} />
                )}
                {subfamily && <AdditionalProducts params={subfamily} view={activeView} />}
              </div>
            </div>
          </div>
        </section>
      )}
    </Fragment>
  );
};
